import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import { Toaster } from "sonner";
import { HomePage } from "./pages/HomePage";
import { AdminLogin } from "./pages/AdminLogin";
import { MemberLogin } from "./pages/MemberLogin";
import { MemberRegister } from "./pages/MemberRegister";
import { CheckInPage } from "./pages/CheckInPage";
import { PaymentSuccess } from "./pages/PaymentSuccess";
import { PaymentCancel } from "./pages/PaymentCancel";
import { WaiverPage } from "./pages/WaiverPage";
import { ClaimFreeClass } from "./pages/ClaimFreeClass";
import { ClaimFreeWeek } from "./pages/ClaimFreeWeek";
import { ResetPassword } from "./pages/ResetPassword";
import TrainerLogin from "./pages/TrainerLogin";
import TrainerRegister from "./pages/TrainerRegister";
import TrainerReview from "./pages/TrainerReview";
import CampaignPage from "./pages/CampaignPage";
import CampaignRedirect from "./pages/CampaignRedirect";
import CampaignSourceRedirect from "./pages/CampaignSourceRedirect";
import GymPartnerPage from "./pages/GymPartnerPage";
import GymPartnerBookingPage from "./pages/GymPartnerBookingPage";
import GymBrandingPage from "./pages/GymBrandingPage";
import MerchCheckoutPage from "./pages/MerchCheckoutPage";
import CustomDietPlanPage from "./pages/CustomDietPlanPage";
import WorkplaceWellness  from "./pages/WorkplaceWellness";

// Heavy authenticated routes — loaded on demand only (code splitting)
const AdminDashboard   = lazy(() => import("./pages/AdminDashboard").then(m => ({ default: m.AdminDashboard })));
const MemberDashboard  = lazy(() => import("./pages/MemberDashboard").then(m => ({ default: m.MemberDashboard })));
const TrainerDashboard = lazy(() => import("./pages/TrainerDashboard"));

// Minimal dark fallback shown while a lazy chunk loads (invisible on fast connections)
const ChunkFallback = () => (
  <div style={{ minHeight: "100vh", background: "#050505" }} />
);
import "./App.css";

// Captures ?ref= from ANY page and persists it in localStorage
const ReferralCapture = () => {
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref");
    if (ref) {
      localStorage.setItem("nbc_referral_code", ref);
    }
    const tref = params.get("tref");
    if (tref) {
      localStorage.setItem("nbc_trainer_referral_code", tref);
    }
  }, [location.search]);
  // TikTok page view on every client-side route change
  useEffect(() => {
    if (window.ttq) window.ttq.page();
  }, [location.pathname]);
  return null;
};

function App() {
  return (
    <div className="App dark">
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#1A1A1A',
            color: '#fff',
            border: '1px solid rgba(255, 182, 18, 0.3)'
          }
        }}
      />
      <BrowserRouter>
        <ReferralCapture />
        <Suspense fallback={<ChunkFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          <Route path="/login" element={<MemberLogin />} />
          <Route path="/register" element={<MemberRegister />} />
          <Route path="/dashboard/*" element={<MemberDashboard />} />
          <Route path="/checkin" element={<CheckInPage />} />
          <Route path="/waiver" element={<WaiverPage />} />
          <Route path="/claim-free-class" element={<ClaimFreeClass />} />
          <Route path="/claim-free-week" element={<ClaimFreeWeek />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/trainer/login" element={<TrainerLogin />} />
          <Route path="/trainer/register" element={<TrainerRegister />} />
          <Route path="/trainer/dashboard" element={<TrainerDashboard />} />
          <Route path="/dashboard/trainer-review" element={<TrainerReview />} />
          <Route path="/clicktowin" element={<CampaignPage />} />
          <Route path="/r/:code"    element={<CampaignRedirect />} />
          <Route path="/gympartnerai"  element={<GymPartnerPage />} />
          <Route path="/gpaibooking"   element={<GymPartnerBookingPage />} />
          <Route path="/gymbranding"   element={<GymBrandingPage />} />
          <Route path="/merch"         element={<MerchCheckoutPage />} />
          <Route path="/custom-diet-plan" element={<CustomDietPlanPage />} />
          <Route path="/workplace-wellness" element={<WorkplaceWellness />} />
          <Route path="/win/:source" element={<CampaignSourceRedirect />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
